import React, { FC } from 'react';

import { Container, ContainerProps } from '@lglp/components';

import LogoGLP from '../../Icons/LogoGLP';
import styles from './LoadingState.module.scss';

export const LoadingState: FC<ContainerProps> = ({
  className,
  error,
  ...rest
}) => (
  <Container className={[styles.container, className]} {...rest}>
    <Container className={styles.icon}>
      <LogoGLP />
    </Container>
  </Container>
);
